import { useQuery } from '@tanstack/react-query';
import { portalDb, type PortalMeRow } from './portalClient';

/** The customer card this login is linked to at the given company. */
export function usePortalMe(companyId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'me'],
    enabled: !!companyId,
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<PortalMeRow | null> => {
      const { data, error } = await portalDb
        .from('portal_me')
        .select('*')
        .eq('company_id', companyId)
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return (data as PortalMeRow | null) ?? null;
    },
  });
}
